import styled from "styled-components";
import { siteDarkBlue } from "../../providers/Theme";

export const Section = styled.section`
  background: white;
  padding: 4rem 1.5rem 0;
`;

export const SectionHeading = styled.h2`
  color: ${siteDarkBlue};
  font-weight: 800;
  font-size: 2rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  text-align: center;
  margin-bottom: 2rem;

  ${({ theme }) => theme.md`font-size: 2.5rem;`}
`;

export const CardsGrid = styled.div`
  max-width: 72rem;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;

  ${({ theme }) => theme.sm`
    grid-template-columns: 1fr 1fr;
  `}

  ${({ theme }) => theme.lg`
    grid-template-columns: repeat(4, 1fr);
  `}
`;

export const Card = styled.div<{ bg: string }>`
  background: ${({ bg }) => bg};
  border-radius: 14px;
  padding: 2rem 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1rem;
`;

export const CardTitle = styled.h3`
  color: white;
  font-weight: 800;
  font-size: 1.75rem;
  text-transform: uppercase;
  line-height: 1.2;
  margin: 0;

  ${({ theme }) => theme.lg`font-size: 1.9rem;`}
`;

export const CardBody = styled.p`
  color: white;
  font-size: 1.35rem;
  line-height: 1.6;
  margin: 0;
  flex: 1;

  ${({ theme }) => theme.md`font-size: 1.5rem;`}
`;

export const CardButton = styled.button`
  background: rgba(255, 255, 255, 0.25);
  border: none;
  border-radius: 8px;
  color: white;
  font-weight: 700;
  font-size: 1.05rem;
  padding: 0.65rem 1.75rem;
  cursor: pointer;
  transition: background 0.15s ease;
  margin-top: 0.5rem;

  &:hover {
    background: rgba(255, 255, 255, 0.4);
  }
`;

export const DisclaimerBand = styled.div`
  padding: 1.5rem 2rem;
  background: white;
`;

export const DisclaimerText = styled.p`
  max-width: 72rem;
  margin: 0 auto;
  color: ${siteDarkBlue};
  font-size: 0.92rem;
  line-height: 1.7;
  text-align: center;
`;
